<template>
<div>
    <v-card>
        <v-card-title>
            <h2 v-if="!edit">{{title}}</h2>
            <v-text-field v-else v-model="title" />
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-html="body" v-if="!edit">
        </v-card-text>
        <section v-else>
            <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
                <v-system-bar color="pink darken-2" dark>
                    <v-btn x-small text :class="{ 'is-active': isActive.bold() }" @click="commands.bold">
                        <v-icon>mdi-format-bold</v-icon>
                    </v-btn>

                    <v-btn x-small text :class="{ 'is-active': isActive.italic() }" @click="commands.italic">
                        <v-icon>mdi-format-italic</v-icon>
                    </v-btn>

                    <v-btn x-small text :class="{ 'is-active': isActive.underline() }" @click="commands.underline">
                        <v-icon>mdi-format-underline</v-icon>
                    </v-btn>

                    <v-btn x-small text :class="{ 'is-active': isActive.code() }" @click="commands.code">
                        <v-icon>mdi-code-braces</v-icon>
                    </v-btn>

                    <v-btn x-small text :class="{ 'is-active': isActive.paragraph() }" @click="commands.paragraph">
                        <v-icon>mdi-format-paragraph</v-icon>
                    </v-btn>

                    <v-btn x-small text :class="{ 'is-active': isActive.heading({ level: 1 }) }" @click="commands.heading({ level: 2 })">
                        H2
                    </v-btn>

                    <v-btn x-small text :class="{ 'is-active': isActive.heading({ level: 2 }) }" @click="commands.heading({ level: 3 })">
                        H3
                    </v-btn>

                    <v-btn x-small text :class="{ 'is-active': isActive.heading({ level: 3 }) }" @click="commands.heading({ level: 4 })">
                        H4
                    </v-btn>

                    <v-btn x-small text :class="{ 'is-active': isActive.bullet_list() }" @click="commands.bullet_list">
                        <v-icon>mdi-format-list-bulleted-square</v-icon>
                    </v-btn>

                    <v-btn x-small text :class="{ 'is-active': isActive.ordered_list() }" @click="commands.ordered_list">
                        <v-icon>mdi-format-list-numbered</v-icon>
                    </v-btn>

                    <v-btn x-small text :class="{ 'is-active': isActive.blockquote() }" @click="commands.blockquote">
                        <v-icon>mdi-format-quote-close</v-icon>
                    </v-btn>

                    <v-btn x-small text :class="{ 'is-active': isActive.code_block() }" @click="commands.code_block">
                        <v-icon>mdi-code-braces-box</v-icon>
                    </v-btn>

                    <v-btn x-small text @click="commands.horizontal_rule">
                        <v-icon>mdi-minus</v-icon>
                    </v-btn>

                    <v-btn x-small text @click="commands.undo">
                        <v-icon>mdi-undo</v-icon>
                    </v-btn>

                    <v-btn x-small text @click="commands.redo">
                        <v-icon>mdi-redo</v-icon>
                    </v-btn>

                </v-system-bar>
            </editor-menu-bar>
            <v-card prominent outlined>
                <editor-content :editor="editor" />
            </v-card>
        </section>
        <v-card-actions>
            <v-btn text color="blue darken-1" @click="toggleEdit">{{label}}</v-btn>
            <v-btn text color="blue darken-1" @click="$store.commit('toggle','helpShown'); edit=false;">Close</v-btn>
        </v-card-actions>
    </v-card>
</div>
</template>

<script>
import {
    Editor,
    EditorContent,
    EditorMenuBar
} from 'tiptap'
import {
    Blockquote,
    CodeBlock,
    HardBreak,
    Heading,
    HorizontalRule,
    OrderedList,
    BulletList,
    ListItem,
    TodoItem,
    TodoList,
    Bold,
    Code,
    Italic,
    Link,
    Strike,
    Underline,
    History,
    TrailingNode,
} from 'tiptap-extensions'

export default {
    name: 'HelpDialog',
    components: {
        EditorContent,
        EditorMenuBar,
    },
    data() {
        return {
            edit: false,
            editor: null,
            label: 'Edit',
        }
    },
    beforeDestroy() {
        if (this.editor) {
            this.editor.destroy()
        }
    },
    methods: {
        toggleEdit() {
            if (this.edit == false) {
                this.label = 'Save'
                this.editor = new Editor({
                    extensions: [
                        new Blockquote(),
                        new BulletList(),
                        new CodeBlock(),
                        new HardBreak(),
                        new Heading({
                            levels: [1, 2, 3, 4, 5]
                        }),
                        new HorizontalRule(),
                        new ListItem(),
                        new OrderedList(),
                        new TodoItem(),
                        new TodoList(),
                        new Link(),
                        new Bold(),
                        new Code(),
                        new Italic(),
                        new Strike(),
                        new Underline(),
                        new History(),
                        new TrailingNode({
                            node: 'paragraph',
                        }),

                    ],
                    content: this.$store.state.mode.helpContent.body,
                })
                this.edit = true
            } else {
                this.label = 'Saving...'
                const o = {
                  shortName: this.$store.state.mode.helpContent.shortName,
                  title: this.$store.state.mode.helpContent.title,
                  body:  this.editor.getHTML(),
                  content:  this.editor.getJSON(),
                }
                this.$root.$emit('saveHelp',o)
                this.body = this.editor.getHTML()
                this.editor.destroy()
                this.label = 'Edit'
                this.edit = false
            }
        },
    },
    computed: {
        title: {
            get() {
                return this.$store.state.mode.helpContent.title
            },
            set(val) {
                let hc = {
                    title: val,
                    body: this.$store.state.mode.helpContent.body,
                    shortName: this.$store.state.mode.helpContent.shortName,
                    content: this.$store.state.mode.helpContent.content,
                }
                this.$store.commit('set', ['helpContent', hc])
            }
        },
        body: {
            get() {
                return this.$store.state.mode.helpContent.body
            },
            set(val) {
                let hc = {
                    body: val,
                    title: this.$store.state.mode.helpContent.title,
                    shortName: this.$store.state.mode.helpContent.shortName,
                    content: this.$store.state.mode.helpContent.content,
                }
                this.$store.commit('set', ['helpContent', hc])
            }
        }
    }
}
</script>
